<template>
  <div>
      <span>{{datenow}}</span>
  </div>
</template>

<script>
export default {
    data (){
        return{
            datenow: ''
        }
    },
    methods:{
        time(){
            let data = new Date()
            // Guarda cada pedaço em uma variável
            let dia     = data.getDate();           // 1-31
            let mes     = data.getMonth();          // 0-11 (zero=janeiro)
            let ano     = data.getFullYear();       // 4 dígitos
            let hora    = data.getHours();          // 0-23
            let min     = data.getMinutes();        // 0-59
            let seg     = data.getSeconds();        // 0-59


            let str_data = `${dia < 10 ? '0' : ''}` + dia + '/' + `${mes < 10 ? '0' : ''}` + (mes+1) + '/' + ano;
            let str_hora = `${hora < 10 ? '0' : ''}` + hora + ':' + `${min < 10 ? '0' : ''}` + min + ':' + `${seg < 10 ? '0' : ''}` + seg;

            this.datenow = `${str_data} ${str_hora}` 
        }
    },
    mounted(){
        this.interval = setInterval(this.time, 1000)
    },
    beforeDestroy() {
        clearInterval(this.interval)
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/current-date-hour.vue